import { Autocomplete, styled } from '@mui/material';
import { device } from '../../constants/devices';
import theme from '../../constants/theme';

const AutocompleteStyled = styled(Autocomplete)({
  border: `5px solid ${theme.palette.primary.light}`,
  background: 'rgba(51, 51, 51, 0.20)',
  backdropFilter: 'blur(20px)',
  borderRadius: 0,
  height: '64px',
  input: {
    fontWeight: 600,
  },
  '.MuiOutlinedInput-notchedOutline': {
    border: 'unset',
  },
  '.MuiAutocomplete-input': {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    fontSize: theme.typography.h6.fontSize,
    padding: '16px 0 0 0 !important',
  },
  '.MuiAutocomplete-input::placeholder': {
    color: theme.palette.secondary.main,
    opacity: 1,
  },
  '.MuiInputBase-root': {
    padding: '0 16px 0 9px !important',
  },
  [device.small]: {
    height: '40px',
    minWidth: 'auto',
    width: '100%',
    '.MuiAutocomplete-input': {
      padding: '4px 0 0 0 !important',
    },
    '.MuiInputBase-root': {
      padding: '4px 16px 0 9px !important',
    },
  },
});

export default AutocompleteStyled;
